import { Button } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useEffect, useState } from 'react'
import { SideDrawerContent } from './SideDrawerContent'
import { SideDrawerIcon } from './SideDrawerIcon'
import { CompProps } from 'types'

export const SideDrawer = ({ children }: CompProps) => {
  const { nativeOverrides, motion } = useTheme()
  const [open, setOpen] = useState(false)
  const handleOnClose = () => setOpen(false)

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [open])

  return (
    <>
      <Button
        className={css`
          ${nativeOverrides.buttonClear};
          width: 20px;
          height: 14px;
          ${motion.transition('opacity')};
          &:hover {
            opacity: 0.7;
          }
        `}
        onClick={() => setOpen(true)}
      >
        <SideDrawerIcon />
      </Button>
      <SideDrawerContent open={open} onClose={handleOnClose}>
        {children}
      </SideDrawerContent>
    </>
  )
}
